import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiToggleButton = {
	defaultProps: { disableRipple: true },
	styleOverrides: {
		root: {
			color: "var(--mui-palette-text-primary)",
			fontSize: "var(--icon-fontSize-md)",
			padding: "6px",
			textTransform: "none",
		},
		sizeSmall: {
			fontSize: "13px",
			padding: "4px 8px",
		},
	},
	variants: [
		{
			props: { size: "xsmall" as const },
			style: {
				fontSize: "11px",
				padding: "2px 6px",
				lineHeight: 1.5,
			},
		},
	],
} satisfies Components<Theme>["MuiToggleButton"];
